module.exports = __webpack_public_path__ + "static/media/guest_book.f822ee28.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola/zola-ui/src/assets/images/icons/guest_book.svg
// module id = 2085
// module chunks = 68